module.exports = __webpack_public_path__ + "img/milkBlush1.cd706f24.jpg";